import React, { useEffect, useState } from 'react'
import { CCol, CRow, CSpinner, CCard, CCardHeader, CCardBody } from '@coreui/react'
import { fs } from '../firebase'
import InfiniteScroll from 'react-infinite-scroller'
import BookmarkCard from './components/BookmarkCard'

export default function Bookmarks() {
  const perPage = 9
  const [bookmarks, setBookMarks] = useState([])
  const [data, setData] = useState({
    bookmarks: [],
    hasMore: true
  })

  async function getBookmarks() {
    try {
      const lastVisble = data.bookmarks.length && data.bookmarks[data.bookmarks.length - 1]
      let query = fs.collection('bookmarks')
        .orderBy('createdAt', 'desc')
        .limit(perPage)

      if (lastVisble) {
        query = query.startAfter(lastVisble)
      }

      const result = await query.get()
      let items = data.bookmarks
      result.docs.forEach(doc => {
        getBookmarksData(doc.data())
        items.push(doc)
      })

      setData({ bookmarks: items, hasMore: result.docs.length !== 0 })
    } catch (error) {
      console.log(error)
    }
  }

  async function getBookmarksData(bookmark) {
    try {
      const bookDocSnapshot = await fs.collection(`books`).doc(bookmark.book.toString()).get()
      const book = bookDocSnapshot.data()
      const chapter = book.chapters.find(item => item.number == bookmark.chapter)
      const verses = chapter.verses.filter(item => bookmark.verses.includes(item.number))

      let sortedVerses = bookmark.verses.sort((a, b) => a - b)
      let verseFromTo = ''
      if (sortedVerses.length == 1) {
        verseFromTo = sortedVerses[0]
      } else {
        for (var i = 0; i < sortedVerses.length; i++) {
          if (i == 0) {
            verseFromTo += `${sortedVerses[i]}`;
            continue;
          }

          if (i == (sortedVerses.length - 1)) {
            if ((sortedVerses[i] - sortedVerses[i - 1]) == 1) {
              verseFromTo += `-${sortedVerses[i]}`;
            } else {
              verseFromTo += `, ${sortedVerses[i]}`;
            }
          } else if ((sortedVerses[i] - sortedVerses[i - 1]) == 1 && (sortedVerses[i + 1] - sortedVerses[i]) == 1) {
            continue;
          } else if ((sortedVerses[i] - verses[i - 1]) == 1 && (sortedVerses[i + 1] - sortedVerses[i]) != 1) {
            verseFromTo += `-${sortedVerses[i]}`;
          } else {
            verseFromTo += `, ${sortedVerses[i]}`;
          }
        }
      }
      let bookmarkTitle = `<strong>${book.name} ${bookmark.chapter}:${verseFromTo}</strong>`
      let bookmarkVerse = ''

      verses.forEach(verse => {
        bookmarkVerse += `<sup>${verse.number}</sup> ${verse.content}. `
      })

      bookmarks.push({ title: bookmarkTitle, content: bookmarkVerse })
      setBookMarks([...bookmarks])
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      <CRow>
        <CCol>
          <h4>Bookmarks</h4>
        </CCol>
      </CRow>
      <InfiniteScroll
        className="row mt-3 mb-5"
        pageStart={0}
        loadMore={() => getBookmarks()}
        hasMore={data.hasMore}
        loader={(
          <div className="col w-100 text-center mt-3">
            <CSpinner
            />
          </div>
        )}
      >
        {
          bookmarks.map(bookmark => {
            return (
              <BookmarkCard
                title={bookmark.title}
                content={bookmark.content}
              />
            )
          })
        }
      </InfiniteScroll>
    </>
  )
}
